// Konstanta & konversi satuan maritim, dipusatkan biar nggak ada angka ajaib
// yang tersebar di banyak komponen. Sumber data GPS (summary & pulse) memakai
// kecepatan dalam km/h dan jarak dalam meter.

// 1 nautical mile = 1852 meter.
export const METERS_PER_NM = 1852;

// 1 km/h = 0.53995... knot (= 1 / 1.852).
export const KMH_TO_KNOT = 0.5399568034557236;

// Kecepatan km/h -> knot. Mengembalikan Number (NaN bila input bukan angka).
export function kmhToKnot(value) {
  return Number(value) * KMH_TO_KNOT;
}

// Jarak meter -> nautical mile. Mengembalikan Number (NaN bila input bukan angka).
export function metersToNm(value) {
  return Number(value) / METERS_PER_NM;
}
